import { prettyName, type DocumentItem } from './useDocumentActions';

interface DocumentCardProps {
  doc: DocumentItem;
  /** Meta riga (default: dimensione · data). Ricerca: percorso cartella. */
  meta?: React.ReactNode;
  onOpen: (doc: DocumentItem, force?: boolean) => void;
  /** Se assente, il pulsante Elimina non viene mostrato (es. viste di sola lettura come la ricerca). */
  onDelete?: (doc: DocumentItem) => void;
}

/**
 * Card documento riusabile (griglia .doc-grid). Presentazionale: la logica di
 * apri/scarica/elimina vive in useDocumentActions ed e' passata via props, cosi'
 * la stessa card serve la lista di livello (con Elimina) e i risultati ricerca
 * (senza Elimina) senza duplicare markup.
 */
export function DocumentCard({ doc, meta, onOpen, onDelete }: DocumentCardProps): React.JSX.Element {
  return (
    <div className="doc-card">
      <div className="doc-card-title">📄 {prettyName(doc.fileName)}</div>
      <div className="doc-card-meta">
        {meta ?? (
          <>
            {Math.round(doc.sizeBytes / 1024)} KB · {new Date(doc.uploadedAt).toLocaleDateString('it-IT')}
          </>
        )}
      </div>
      <div className="doc-card-actions">
        <button className="btn-info" style={{ padding: '6px 12px', fontSize: 13 }}
          onClick={() => onOpen(doc, false)}>👁 Visualizza</button>
        <button className="btn-success" style={{ padding: '6px 12px', fontSize: 13 }}
          onClick={() => onOpen(doc, true)}>📥 Scarica</button>
        {onDelete && (
          <button className="btn-delete" style={{ padding: '6px 12px', fontSize: 13 }}
            onClick={() => onDelete(doc)}>🗑 Elimina</button>
        )}
      </div>
    </div>
  );
}
